import useSWRMutation from 'swr/mutation';
import { useAuth0 } from '@auth0/auth0-react';
import http from '@/Utils/HTTP/NewHttpUtils';

export interface LocationAutocompleteResponse {
    cities: string[];
    regions: string[];
    countries: string[];
}

const DefaultLocationAutocompleteResponse: LocationAutocompleteResponse = {
    cities: [],
    regions: [],
    countries: [],
};

const useLocationAutocompleteOptions = () => {
    const { getAccessTokenSilently } = useAuth0();

    return useSWRMutation('profiles/location-autocomplete', async (path: string, { arg }: { arg: string }) => {
        if (arg.length < 2) {
            return DefaultLocationAutocompleteResponse;
        }

        const response = await http.post<LocationAutocompleteResponse>({
            path,
            accessToken: await getAccessTokenSilently(),
            body: { query: arg },
        });

        return response || DefaultLocationAutocompleteResponse;
    });
};

export default useLocationAutocompleteOptions;
